<template>
  <component
    :is="path ? 'router-link' : 'div'"
    :to="path"
    :class="[theme ? 'historynav-button--theme-' + theme : null]"
    class="historynav-button"
  >
    <ul class="historynav-button__pictos">
      <li class="historynav-button__picto historynav-button__picto--top">
        <div :class="['historynav-button__pic', pictoTop]" />
      </li>

      <li class="historynav-button__picto historynav-button__picto--bottom">
        <div :class="['historynav-button__pic', pictoBottom]" />
      </li>
    </ul>
    <div class="historynav-button__label">
      {{ year }} <br> {{ name }}
    </div>
  </component>
</template>

<script>
export default {
  name: 'HistoryNavButton',
  props: {
    year: { type: String, default: null },
    name: { type: String, default: null },
    theme: { type: String, default: null },
    path: { type: Object, default: null },
    pictoTop: { type: String, default: null },
    pictoBottom: { type: String, default: null },
  },
};
</script>

<style lang="stylus">
.historynav-button {
  position: relative;
}

.historynav-button__pictos {
  display: flex;
  flex-direction: column;
}

a.router-link-exact-active {
  pointer-events: none;
  .historynav-button__picto {
    &:before {
      display: none;
    }
  }
}

.historynav-button__picto {
  position: relative;
  margin: 0 auto;
  width: 60px !important;
  height: @width;
  background-size: 100% !important;
  border-radius: @width;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    border: 1px solid $cl-white;
    border-radius: 100%;
  }

  .historynav-button--theme-green & { background-color: $cl-green; }
  .historynav-button--theme-purple & { background-color: $cl-purple; }
  .historynav-button--theme-orange & { background-color: $cl-orange; }

  &--bottom {
    position: relative;
    top: -20px;
    transition: transform 0.25s ease-in-out 0s;

    +pointer-device() {
      a.historynav-button:hover & {
        transform: translateY(-25%);
      }

    }
  }
}

.historynav-button__pic {
  position: relative;
  z-index: 1;
  width: 100% !important;
  height: 100% !important;
  background-size: 100% !important;
}

.historynav-button__label {
  @extend $typo-history-nav;
  color: $cl-white;
  margin-top: -10px;
  text-align: center;
  text-transform: uppercase;
}
</style>
